
        var result = require("!!../../../../node_modules/css-loader/index.js!./training.details.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/training/training.details.component.css
// module id = 1255
// module chunks = 0